import { render } from "./LoginNoPassword.vue?vue&type=template&id=a6512b78&scoped=true"
import script from "./LoginNoPassword.vue?vue&type=script&lang=js"
export * from "./LoginNoPassword.vue?vue&type=script&lang=js"

import "./LoginNoPassword.vue?vue&type=style&index=0&id=a6512b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6512b78"]])

export default __exports__